import React, { Component } from 'react';
import { DragSource } from 'react-dnd';


const Types = {
	ITEM: 'product-remove'
};
const itemSource = {
	beginDrag(props) {
		//TIDI Rename canDelete func
		props.canDelete(true)
		props.addDraggingProductToState({productDetails: props.details})
		return ({id: props.details.id})
	},

	endDrag(props) {
		props.canDelete(false)
	}
};

function collect(connect, monitor) {
	return {
		connectDragSource: connect.dragSource(),
		isDragging: monitor.isDragging(),
		connectDragPreview: connect.dragPreview()
	}
}

class ActiveProduct extends Component {
	_putInCell(startCellId, endCellId, type) {
		const { activeInitialBaseplate } = this.props.appState;

		if (endCellId - startCellId === 12) {
			if (activeInitialBaseplate === '10x3') {
				return {
					startRow: startCellId <= 10 ? 1 : startCellId <= 20 ? 2 : 3,
					endRow: startCellId <= 10 ? 3 : startCellId <= 20 ? 4 : 5,
					startColumn: startCellId <= 2 ? 1 : startCellId <= 4 ? 3 : startCellId <= 10 ? 5 : startCellId <= 12 ? 1 : startCellId <= 14 ? 3  : startCellId <= 20 ? 5 : startCellId <= 22 ? 1 : startCellId <= 24 ? 3 : startCellId <= 30 ? 5 : 3,
					endColumn: startCellId <= 2 ? 7 : startCellId <= 4 ? 9 : startCellId <= 10 ? 11 : startCellId <= 12 ? 7 : startCellId <= 14 ? 9 : startCellId <= 20 ? 11: startCellId <= 22 ? 7 : startCellId <= 24 ? 9 : startCellId <= 30 ? 11 : 7
				}
			}

			else if (activeInitialBaseplate === '10x2_KOMPANJA') {
				return {
					startRow: 1,
					endRow: 3,
					startColumn: startCellId <= 2 ? 1 : startCellId <= 4 ? 3 : startCellId <= 10 ? 5 : 1,
					endColumn: startCellId <= 2 ? 7 : startCellId <= 4 ? 9 : startCellId <= 10 ? 11 : 5
				}
			}

			else if (activeInitialBaseplate === '8x1') {
				return {
					startRow: 1,
					endRow: 3,
					startColumn: startCellId <= 2 ? 1 : 3,
					endColumn: startCellId <= 2 ? 7 : 9
				}
			}

			else if (activeInitialBaseplate === '8x2') {
				return {
					startRow: startCellId <= 8 ? 1 : 2,
					endRow: startCellId <= 8 ? 3 : 4,
					startColumn: startCellId <= 2 ? 1 : startCellId <= 8 ? 3 : startCellId <= 10 ? 1 : 3,
					endColumn: startCellId <= 2 ? 7 : startCellId <= 8 ? 9 : startCellId <= 10 ? 7 : startCellId <= 16 ? 9 : 5
				}
			}

			// Else condition would work as well, but to make it clearer what will be applied
			else if (activeInitialBaseplate === '6x2') {
				return {
					startRow: startCellId <= 6 ? 1 : 2,
					endRow: startCellId <= 6 ? 3 : 4,
					startColumn: 1,
					endColumn: 7
				}
			}

			else if (activeInitialBaseplate === '12x1') {
				return {
					startRow: 1,
					endRow: 3,
					startColumn: startCellId <= 2 ? 1 : startCellId <= 4 ? 3 : startCellId <= 6 ? 5 : 7,
					endColumn: startCellId <= 2 ? 7 : startCellId <= 4 ? 9 : startCellId <= 6 ? 11 : 13
				}
			}

			// 6x3
			else {
				return {
					startRow: startCellId <= 6 ? 1 : startCellId <= 12 ? 2 : 3,
					endRow: startCellId <= 6 ? 3 : startCellId <= 12 ? 4 : 5,
					startColumn: 1,
					endColumn: 7
				}
			}
		}

    if (endCellId - startCellId === 18) {
			if (activeInitialBaseplate === '10x3') {
				return {
					startRow: startCellId <= 10 ? 1 : startCellId <= 20 ? 2 : 3,
					endRow: startCellId <= 10 ? 4 : startCellId <= 20 ? 5 : 6,
					startColumn: startCellId <= 2 ? 1 : startCellId <= 4 ? 3 : startCellId <= 10 ? 5 : startCellId <= 12 ? 1 : startCellId <= 14 ? 3  : startCellId <= 20 ? 5 : startCellId <= 22 ? 1 : startCellId <= 24 ? 3 : startCellId <= 30 ? 5 : 3,
					endColumn: startCellId <= 2 ? 7 : startCellId <= 4 ? 9 : startCellId <= 10 ? 11 : startCellId <= 12 ? 7 : startCellId <= 14 ? 9 : startCellId <= 20 ? 11: startCellId <= 22 ? 7 : startCellId <= 24 ? 9 : startCellId <= 30 ? 11 : 7
				}
			}

			else if (activeInitialBaseplate === '10x2_KOMPANJA') {
				return {
					startRow: 1,
					endRow: 4,
					startColumn: startCellId <= 2 ? 1 : startCellId <= 4 ? 3 : startCellId <= 10 ? 5 : 1,
					endColumn: startCellId <= 2 ? 7 : startCellId <= 4 ? 9 : startCellId <= 10 ? 11 : 5
				}
			}

			else if (activeInitialBaseplate === '8x1') {
				return {
					startRow: 1,
					endRow: 4,
					startColumn: startCellId <= 2 ? 1 : 3,
					endColumn: startCellId <= 2 ? 7 : 9
				}
			}

			else if (activeInitialBaseplate === '8x2') {
				return {
					startRow: startCellId <= 8 ? 1 : 2,
					endRow: startCellId <= 8 ? 4 : 5,
					startColumn: startCellId <= 2 ? 1 : startCellId <= 8 ? 3 : startCellId <= 10 ? 1 : 3,
					endColumn: startCellId <= 2 ? 7 : startCellId <= 8 ? 9 : startCellId <= 10 ? 7 : startCellId <= 16 ? 9 : 5
				}
			}

			// Else condition would work as well, but to make it clearer what will be applied
			else if (activeInitialBaseplate === '6x2') {
				return {
					startRow: startCellId <= 6 ? 1 : 2,
					endRow: startCellId <= 6 ? 4 : 5,
					startColumn: 1,
					endColumn: 7
				}
			}

			else if (activeInitialBaseplate === '12x1') {
				return {
					startRow: 1,
					endRow: 4,
					startColumn: startCellId <= 2 ? 1 : startCellId <= 4 ? 3 : startCellId <= 6 ? 5 : 7,
					endColumn: startCellId <= 2 ? 7 : startCellId <= 4 ? 9 : startCellId <= 6 ? 11 : 13
				}
			}

			// 6x3
			else {
				return {
					startRow: startCellId <= 6 ? 1 : startCellId <= 12 ? 2 : 3,
					endRow: startCellId <= 6 ? 4 : startCellId <= 12 ? 5 : 6,
					startColumn: 1,
					endColumn: 7
				}
			}
		}

		else if (endCellId - startCellId === 16) {
			if (activeInitialBaseplate === '10x3') {
				return {
					startRow: startCellId <= 10 ? 1 : startCellId <= 20 ? 2 : 3,
					endRow: startCellId <= 10 ? 3 : startCellId <= 20 ? 4 : 5,
					startColumn: startCellId <= 2 ? 1 : startCellId <= 10 ? 3 : startCellId <= 12 ? 1 :  startCellId <= 20 ? 3 : startCellId <= 22 ? 1 : startCellId <= 30 ? 3 : 3,
					endColumn: startCellId <= 2 ? 9 : startCellId <= 10 ? 11 : startCellId <= 12 ? 9 :  startCellId <= 20 ? 11: startCellId <= 22 ? 9 : startCellId <= 30 ? 11 : 7
				}
			}

			else if (activeInitialBaseplate === '10x2_KOMPANJA') {
				return {
					startRow: 1,
					endRow: 3,
					startColumn: startCellId <= 2 ? 1 : startCellId <= 10 ? 3 : 1,
					endColumn: startCellId <= 2 ? 9 : startCellId <= 10 ? 11 : 5
				}
			}

			else if (activeInitialBaseplate === '8x1') {
				return {
					startRow: 1,
					endRow: 3,
					startColumn: 1,
					endColumn: 9
				}
			}

			else if (activeInitialBaseplate === '8x2') {
				return {
					startRow: startCellId <= 8 ? 1 : 2,
					endRow: startCellId <= 8 ? 3 : 4,
					startColumn: 1,
					endColumn: 9
				}
			}


			else if (activeInitialBaseplate === '12x1') {
				return {
					startRow: 1,
					endRow: 3,
					startColumn: startCellId <= 2 ? 1 : startCellId <= 4 ? 3 : 5,
					endColumn: startCellId <= 2 ? 9 : startCellId <= 4 ? 11 : 13
				}
			}
		}

		// This statement will work only with big pocket
		else if (endCellId - startCellId === 8) {
			if (activeInitialBaseplate === '10x3') {
				return {
					startRow: startCellId <= 10 ? 1 : startCellId <= 20 ? 2 : 3,
					endRow: startCellId <= 10 ? 3 : startCellId <= 20 ? 4 : 5,
					startColumn: startCellId <= 2 ? 1 : startCellId <= 4 ? 3 : startCellId <= 6 ? 5 : startCellId <= 10 ? 7 : startCellId <= 12 ? 1 : startCellId <= 14 ? 3 : startCellId <= 16 ?  5 : startCellId <= 20 ? 7 : startCellId <= 22 ? 1 : startCellId <= 24 ? 3 : startCellId <= 26 ? 5 : startCellId <= 30 ? 7 : 3,
					endColumn: startCellId <= 2 ? 5 : startCellId <= 4 ? 7 : startCellId <= 6 ? 9 : startCellId <= 10 ? 11 : startCellId <= 12 ? 5 : startCellId <= 14 ? 7 : startCellId <= 16 ? 9 : startCellId <= 20 ? 11: startCellId <= 22 ? 5 : startCellId <= 24 ? 7 : startCellId <= 26 ? 9 : startCellId <= 30 ? 11 : 7
				}
			}

			else if (activeInitialBaseplate === '10x2_KOMPANJA') {
				return {
					startRow: 1,
					endRow: 3,
					startColumn: startCellId <= 2 ? 1 : startCellId <= 4 ? 3 : startCellId <= 6 ? 5 : startCellId <= 10 ? 7 : 1,
					endColumn: startCellId <= 2 ? 5 : startCellId <= 4 ? 7 : startCellId <= 6 ? 9 : startCellId <= 10 ? 11 : 5
				}
			}

			else if (activeInitialBaseplate === '8x1') {
				return {
					startRow: 1,
					endRow: 3,
					startColumn: startCellId <= 2 ? 1 : startCellId <= 4 ? 3 : startCellId <= 8 ? 5 :  1,
					endColumn: startCellId <= 2 ? 5 : startCellId <= 4 ? 7 : startCellId <= 8 ? 9 : 5
				}
			}

			else if (activeInitialBaseplate === '8x2') {
				return {
					startRow: startCellId <= 8 ? 1 : 2,
					endRow: startCellId <= 8 ? 3 : 4,
					startColumn: startCellId <= 2 ? 1 : startCellId <= 4 ? 3 : startCellId <= 8 ? 5 : startCellId <= 10 ? 1 : startCellId <= 12 ? 3 : startCellId <= 16 ? 5 : 1,
					endColumn: startCellId <= 2 ? 5 : startCellId <= 4 ? 7 : startCellId <= 8 ? 9 : startCellId <= 10 ? 5 : startCellId <= 12 ? 7 : startCellId <= 16 ? 9 : 5
				}
			}

			// Else condition would work as well, but to make it clearer what will be applied
			else if (activeInitialBaseplate === '6x2') {
				return {
					startRow: startCellId <= 6 ? 1 : 2,
					endRow: startCellId <= 6 ? 3 : 4,
					startColumn: startCellId <= 2 ? 1 : startCellId <= 6 ? 3 : startCellId <= 8 ? 1 : startCellId <= 12 ? 3 : 3,
					endColumn: startCellId <= 2 ? 5 : startCellId <= 6 ? 7 : startCellId <= 8 ? 5 : startCellId <= 12 ? 7 : 7
				}
			}

			else if (activeInitialBaseplate === '12x1') {
				return {
					startRow: 1,
					endRow: 3,
					startColumn: startCellId <= 2 ? 1 : startCellId <= 4 ? 3 : startCellId <= 6 ? 5 : startCellId <= 8 ? 7 : startCellId <= 12 ? 9 : 1,
					endColumn: startCellId <= 2 ? 5 : startCellId <= 4 ? 7 : startCellId <= 6 ? 9 : startCellId <= 8 ? 11 : startCellId <= 12 ? 13 : 1
				}
			}

			else if (activeInitialBaseplate === '4x4') {
				return {
					startRow: startCellId <= 4 ? 1 : startCellId <= 8 ? 2 : startCellId <= 12 ? 3 : 4,
					endRow: startCellId <= 4 ? 3 : startCellId <= 8 ? 4 : startCellId <= 12 ? 5 : 6,
					startColumn: 1,
					endColumn: 5
				}
			}

			else if (activeInitialBaseplate === '4x3') {
				return {
					startRow: startCellId <= 4 ? 1 : startCellId <= 8 ? 2 : 3,
					endRow: startCellId <= 4 ? 3 : startCellId <= 8 ? 4 : 5,
					startColumn: 1,
					endColumn: 5
				}
			}

			else if (activeInitialBaseplate === '4x2') {
				return {
					startRow: startCellId <= 4 ? 1 : 2,
					endRow: startCellId <= 4 ? 3 : 4,
					startColumn: 1,
					endColumn: 5
				}
			}

			else {
				return {
					startRow: startCellId <= 6 ? 1 : startCellId <= 12 ? 2 : 3,
					endRow: startCellId <= 6 ? 3 : startCellId <= 12 ? 4 : 5,
					startColumn: startCellId <= 2 ? 1 : startCellId <= 6 ? 3 : startCellId <= 8 ? 1 : startCellId <= 12 ? 3 : startCellId <= 14 ? 1 : 3,
					endColumn: startCellId <= 2 ? 5 : startCellId <= 6 ? 7 : startCellId <= 8 ? 5 : startCellId <= 12 ? 7 : startCellId <= 14 ? 5 : 7
				}
			}
		}

		// This statement will work only with PocketBottle
		else if (endCellId - startCellId === 6 && type === 'pocket-b') {
			if (activeInitialBaseplate === '10x3') {
				return {
					startRow: startCellId <= 10 ? 1 : startCellId <= 20 ? 2 : 3,
					endRow: startCellId <= 10 ? 3 : startCellId <= 20 ? 4 : 5,
					startColumn: startCellId <= 2 ? 1 : startCellId <= 4 ? 3 : startCellId <= 6 ? 5  : startCellId <= 8 ? 7 : startCellId <= 10 ? 9 : startCellId <= 12 ? 1 : startCellId <= 14 ? 3 : startCellId <= 16 ?  5 : startCellId <= 18 ? 7 : startCellId <= 20 ? 9 : startCellId <= 22 ? 1 : startCellId <= 24 ? 3 : startCellId <= 26 ? 5 : startCellId <= 28 ? 7 : startCellId <= 30 ? 9 : 3,
					endColumn: startCellId <= 2 ? 3 : startCellId <= 4 ? 5 : startCellId <= 6 ? 7 : startCellId <= 8 ? 9 : startCellId <= 10 ? 11 : startCellId <= 12 ? 3 : startCellId <= 14 ? 5 : startCellId <= 16 ? 7 : startCellId <= 18 ? 9 : startCellId <= 20 ? 11: startCellId <= 22 ? 3 : startCellId <= 24 ? 5 : startCellId <= 26 ? 7 : startCellId <= 28 ? 9 : startCellId <= 30 ? 11 : 7
				}
			}

			else if (activeInitialBaseplate === '10x2_KOMPANJA') {
				return {
					startRow: 1,
					endRow: 3,
					startColumn: startCellId <= 2 ? 1 : startCellId <= 4 ? 3 : startCellId <= 6 ? 5  : startCellId <= 8 ? 7 : startCellId <= 10 ? 9 : 1,
					endColumn: startCellId <= 2 ? 3 : startCellId <= 4 ? 5 : startCellId <= 6 ? 7 : startCellId <= 8 ? 9 : startCellId <= 10 ? 11 : 3
				}
			}

			else if (activeInitialBaseplate === '8x1') {
				return {
					startRow: 1,
					endRow: 3,
					startColumn: startCellId <= 2 ? 1 : startCellId <= 4 ? 3 : startCellId <= 6 ? 5  : startCellId <= 8 ? 7 : 1,
					endColumn: startCellId <= 2 ? 3 : startCellId <= 4 ? 5 : startCellId <= 6 ? 7 : startCellId <= 8 ? 9 : 3
				}
			}

			else if (activeInitialBaseplate === '8x2') {
				return {
					startRow: startCellId <= 8 ? 1 : 2,
					endRow: startCellId <= 8 ? 3 : 4,
					startColumn: startCellId <= 2 ? 1 : startCellId <= 4 ? 3 : startCellId <= 6 ? 5  : startCellId <= 8 ? 7 : startCellId <= 10 ? 1 : startCellId <= 12 ? 3 : startCellId <= 14 ? 5  : startCellId <= 16 ? 7 : 1,
					endColumn: startCellId <= 2 ? 3 : startCellId <= 4 ? 5 : startCellId <= 6 ? 7 : startCellId <= 8 ? 9 : startCellId <= 10 ? 3 : startCellId <= 12 ? 5 : startCellId <= 14 ? 7 : startCellId <= 16 ? 9 : 3
				}
			}

			else if (activeInitialBaseplate === '6x2') {
				return {
					startRow: startCellId <= 6 ? 1 :2,
					endRow: startCellId <= 6 ? 3 : 4,
					startColumn: startCellId <= 2 ? 1 : startCellId <= 4 ? 3 : startCellId <= 6 ? 5 : startCellId <= 8 ? 1 : startCellId <= 10 ? 3 : startCellId <= 12 ? 5 : 5,
					endColumn: startCellId <= 2 ? 3 : startCellId <= 4 ? 5 : startCellId <= 6 ? 7 : startCellId <= 8 ? 3 : startCellId <= 10 ? 5 : startCellId <= 12 ? 7 : 7	
				}
			}

			else if (activeInitialBaseplate === '2x2') {
				return {
					startRow: startCellId <= 2 ? 1 :2,
					endRow: startCellId <= 2 ? 3 : 4,
					startColumn: 1,
					endColumn: 3	
				}
			}

			else if (activeInitialBaseplate === '2x3') {
				return {
					startRow: startCellId <= 2 ? 1 : startCellId <= 4 ? 2 : 3,
					endRow: startCellId <= 2 ? 3 : startCellId <= 4 ? 4 : 5,
					startColumn: 1,
					endColumn: 3	
				}
			}

			else if (activeInitialBaseplate === '2x4') {
				return {
					startRow: startCellId <= 2 ? 1 : startCellId <= 4 ? 2 : startCellId <= 6 ? 3 : 4,
					endRow: startCellId <= 2 ? 3 : startCellId <= 4 ? 4 : startCellId <= 6 ? 5 : 6,
					startColumn: 1,
					endColumn: 3	
				}
			}

			else if (activeInitialBaseplate === '12x1') {
				return {
					startRow: 1,
					endRow: 3,
					startColumn: startCellId <= 2 ? 1 : startCellId <= 4 ? 3 : startCellId <= 6 ? 5  : startCellId <= 8 ? 7 : startCellId <= 10 ? 9 : startCellId <= 12 ? 11 : 1,
					endColumn: startCellId <= 2 ? 3 : startCellId <= 4 ? 5 : startCellId <= 6 ? 7 : startCellId <= 8 ? 9 : startCellId <= 10 ? 11 : startCellId <= 12 ? 13 : 1
				}
			}

			else if (activeInitialBaseplate === '4x4') {
				return {
					startRow: startCellId <= 4 ? 1 : startCellId <= 8 ? 2 : startCellId <= 12 ? 3 : 4,
					endRow: startCellId <= 4 ? 3 : startCellId <= 8 ? 4 : startCellId <= 12 ? 5 : 6,
					startColumn: (startCellId === 1 || startCellId === 5 || startCellId === 9 || startCellId === 13) ? 1 : 3,
					endColumn: (startCellId === 1 || startCellId === 5 || startCellId === 9 || startCellId === 13) ? 3 : 5
				}
			}

			else if (activeInitialBaseplate === '4x3') {
				return {
					startRow: startCellId <= 4 ? 1 : startCellId <= 8 ? 2 : 3,
					endRow: startCellId <= 4 ? 3 : startCellId <= 8 ? 4 : 5,
					startColumn: (startCellId === 1 || startCellId === 5 || startCellId === 9) ? 1 : 3,
					endColumn: (startCellId === 1 || startCellId === 5 || startCellId === 9) ? 3 : 5
				}
			}

			else if (activeInitialBaseplate === '4x2') {
				return {
					startRow: startCellId <= 4 ? 1 : 2,
					endRow: startCellId <= 4 ? 3 : 4,
					startColumn: (startCellId === 1 || startCellId === 5) ? 1 : 3,
					endColumn: (startCellId === 1 || startCellId === 5) ? 3 : 5
				}
			}

			else {
				return {
					startRow: startCellId <= 6 ? 1 : startCellId <= 12 ? 2 : 3,
					endRow: startCellId <= 6 ? 3 : startCellId <= 12 ? 4 : 5,
					startColumn: startCellId <= 2 ? 1 : startCellId <= 4 ? 3 : startCellId <= 6 ? 5 : startCellId <= 8 ? 1 : startCellId <= 10 ? 3 : startCellId <= 12 ? 5 : startCellId <= 14 ? 1 : startCellId <= 16 ? 3 : startCellId <= 18 ? 5 : 1,
					endColumn: startCellId <= 2 ? 3 : startCellId <= 4 ? 5 : startCellId <= 6 ? 7 : startCellId <= 8 ? 3 : startCellId <= 10 ? 5 : startCellId <= 12 ? 7 : startCellId <= 14 ? 3 : startCellId <= 15 ? 5 : startCellId <= 18 ? 7 : 17	
				}
			}
		}

		// Other products
		else {
			if (activeInitialBaseplate === '10x3') {
				// No idea how this works. But it does.
				if (startCellId >= 11 && endCellId <= 21) {
					return {
						startRow: 2,
						endRow: 2,
						startColumn: startCellId - 10,
						endColumn: endCellId - 10
					}
				}
		
				else if (startCellId >= 21) {
					return {
						startRow: 3,
						endRow: 3,
						startColumn: startCellId - 20,
						endColumn: endCellId - 20
					}
				}
		
				else {
					return {
						startRow: 1,
						endRow: 1,
						startColumn: startCellId,
						endColumn: endCellId
					}
				}
			}

			else if (activeInitialBaseplate === '10x2_KOMPANJA') {
				if (startCellId >= 11 && endCellId <= 21) {
					return {
						startRow: 2,
						endRow: 2,
						startColumn: startCellId - 10,
						endColumn: endCellId - 10
					}
				}

				else {
					return {
						startRow: 1,
						endRow: 1,
						startColumn: startCellId,
						endColumn: endCellId
					}
				}
			}

			else if (activeInitialBaseplate === '8x1') {
				return {
					startRow: 1,
					endRow: 2,
					startColumn: startCellId,
					endColumn: endCellId
				}
			}

			else if (activeInitialBaseplate === '8x2') {
				return {
					startRow: startCellId <= 8 ? 1 : 2,
					endRow: startCellId <= 8 ? 2 : 3,
					startColumn: startCellId <= 8 ? startCellId : startCellId - 8,
					endColumn: startCellId <= 8 ? endCellId : endCellId - 8
				}
			}

			else if (activeInitialBaseplate === '6x2') {
				if (startCellId >= 7) {					
					return {
						startRow: 2,
						endRow: 3,
						startColumn: startCellId - 6,
						endColumn: endCellId - 6
					}
				}
		
				else {
					return {
						startRow: 1,
						endRow: 1,
						startColumn: startCellId,
						endColumn: endCellId
					}
				}
			}

			else if (activeInitialBaseplate === '2x2') {
				if (startCellId >= 3) {					
					return {
						startRow: 2,
						endRow: 3,
						startColumn: startCellId - 2,
						endColumn: endCellId - 2
					}
				}
		
				else {
					return {
						startRow: 1,
						endRow: 2,
						startColumn: startCellId,
						endColumn: endCellId
					}
				}
			}

			else if (activeInitialBaseplate === '2x3') {
				if (startCellId >= 5) {					
					return {
						startRow: 3,
						endRow: 4,
						startColumn: startCellId - 4,
						endColumn: endCellId - 4
					}
				}
				
				else if (startCellId >= 3) {					
					return {
						startRow: 2,
						endRow: 3,
						startColumn: startCellId - 2,
						endColumn: endCellId - 2
					}
				}
		
				else {
					return {
						startRow: 1,
						endRow: 2,
						startColumn: startCellId,
						endColumn: endCellId
					}
				}
			}

			else if (activeInitialBaseplate === '2x4') {
				
				if (startCellId >= 7) {					
					return {
						startRow: 4,
						endRow: 5,
						startColumn: startCellId - 6,
						endColumn: endCellId - 6
					}
				}
				
				else if (startCellId >= 5) {										
					return {
						startRow: 3,
						endRow: 4,
						startColumn: startCellId - 4,
						endColumn: endCellId - 4
					}
				}
				
				else if (startCellId >= 3) {					
					return {
						startRow: 2,
						endRow: 3,
						startColumn: startCellId - 2,
						endColumn: endCellId - 2
					}
				}
		
				else {
					return {
						startRow: 1,
						endRow: 2,
						startColumn: startCellId,
						endColumn: endCellId
					}
				}
			}

			else if (activeInitialBaseplate === '12x1') {
				return {
					startRow: 1,
					endRow: 2,
					startColumn: startCellId,
					endColumn: endCellId
				}
			}

			else if (activeInitialBaseplate === '4x4') {
				if (startCellId >= 13) {					
					return {
						startRow: 4,
						endRow: 5,
						startColumn: startCellId - 12,
						endColumn: endCellId - 12
					}
				}
				
				else if (startCellId >= 9) {					
					return {
						startRow: 3,
						endRow: 4,
						startColumn: startCellId - 8,
						endColumn: endCellId - 8
					}
				}
		
				else if (startCellId >= 5) {					
					return {
						startRow: 2,
						endRow: 3,
						startColumn: startCellId - 4,
						endColumn: endCellId - 4
					}
				}

				else {
					return {
						startRow: 1,
						endRow: 2,
						startColumn: startCellId,
						endColumn: endCellId
					}
				}
			}

			else if (activeInitialBaseplate === '4x3') {
				
			if (startCellId >= 9) {					
					return {
						startRow: 3,
						endRow: 4,
						startColumn: startCellId - 8,
						endColumn: endCellId - 8
					}
				}
		
				else if (startCellId >= 5) {					
					return {
						startRow: 2,
						endRow: 3,
						startColumn: startCellId - 4,
						endColumn: endCellId - 4
					}
				}

				else {
					return {
						startRow: 1,
						endRow: 2,
						startColumn: startCellId,
						endColumn: endCellId
					}
				}
			}

			else if (activeInitialBaseplate === '4x2') {		
				if (startCellId >= 5) {					
					return {
						startRow: 2,
						endRow: 3,
						startColumn: startCellId - 4,
						endColumn: endCellId - 4
					}
				}

				else {
					return {
						startRow: 1,
						endRow: 2,
						startColumn: startCellId,
						endColumn: endCellId
					}
				}
			}

			// Default baseplate
			else {
				// No idea how this works. But it does.
				if (startCellId >= 7 && endCellId <= 13) {
					return {
						startRow: 2,
						endRow: 2,
						startColumn: startCellId - 6,
						endColumn: endCellId - 6
					}
				}
		
				else if (startCellId >= 13) {
					return {
						startRow: 3,
						endRow: 3,
						startColumn: startCellId - 12,
						endColumn: endCellId - 12
					}
				}
		
				else {
					return {
						startRow: 1,
						endRow: 1,
						startColumn: startCellId,
						endColumn: endCellId
					}
				}
			}
		}
	}


	render() {
		const {startCell, endCell, type, connectDragSource} = this.props;
		return connectDragSource (
			<div className="active-product cell" 
			style={{
				gridRowStart: this._putInCell(startCell, endCell, type).startRow,
				gridRowEnd: this._putInCell(startCell, endCell, type).endRow,
				gridColumnStart: this._putInCell(startCell, endCell, type).startColumn, 
				gridColumnEnd: this._putInCell(startCell, endCell, type).endColumn,
			}}>
					<img className={type} style={{color: 'black'}} src={this.props.imgSrc} alt="Details" />
			</div>
		)
	}
}
export default DragSource(Types.ITEM, itemSource, collect)(ActiveProduct)